import React, { useState } from "react";
import Modal from "./Modal";

function Card(props) {
  const [model, setModel] = useState(false);
  const [tempData, setTempData] = useState([]);
  //const [vid, setvid] = useState(false);
  const getData = (img, title, content, live, github) => {
    console.log(img);
    let tempData = [img, title, content, live, github];
    setTempData((item) => [1, ...tempData]);
    return setModel(true);
  };
  return (
    <div className="col-md-4 col-sm-12 mx-auto ">
      <div
        className="card tech-stack back_color"
        style={{
          borderRadius: "10px",
          boxShadow: "3px 3px 20px rgba(80,78,78,0.5)",
        }}
        // onMouseEnter={() => setvid(true)}
        // onMouseLeave={() => setvid(false)}
      >
        <img src={props.imgsrc} className="card-img-top" alt="..." />

        <div className="card-body">
          <h2 className="f_color">
            {props.title}{" "}
            <span
              style={{
                fontSize: "1rem",
                float: "right",
                marginTop: "5%",
                color: "aliceblue",
              }}
              className="d_color"
            >
              {props.Date}
            </span>
          </h2>
          {props.stacks.map((val, idx) => {
            return <img className="tech-stack-link" src={val} alt="" />;
          })}
          <div className="text-center m-2">
            <button
              style={{ backgroundColor: "#151515" }}
              className="btn-get-started main-color"
              onClick={() =>
                getData(
                  props.video,
                  props.title,
                  props.content,
                  props.live,
                  props.github
                )
              }
            >
              Open Project
            </button>
          </div>
        </div>
      </div>
      {model === true ? (
        <Modal
          video={tempData[1]}
          title={tempData[2]}
          content={tempData[3]}
          live={tempData[4]}
          github={tempData[5]}
          hide={() => setModel(false)}
        />
      ) : (
        ""
      )}
    </div>
  );
}

export default Card;
